export default {"src":"/_next/static/media/event-streaming-bg.55ee42a9.svg","height":587,"width":1320,"blurWidth":0,"blurHeight":0};